export const UK_PHONE_NUMBER = '020 3778 0274';
export const DE_PHONE_NUMBER = '069 9432 3020';
